import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import FileWrapperMultiViewPdf from './FileWrapperMultiViewPdf.vue';
import useFileWrapperMultiView from '../../composables/use-file-wrapper-multi-view';
import _ from 'lodash';
import { getI18nInstance } from '@/locales/i18nInstance';
import { Icon as PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/profile.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileWrapperRejection',
  setup(__props) {

const i18n = getI18nInstance();

const { currentRoundDetail } = useFileWrapperMultiView();

const rejectionData = computed(() => {
    return _.get(currentRoundDetail.value, 'rejection', {});
});

const title = computed(() => {
    const mrdt = _.get(rejectionData.value, 'mrdt', '');
    const rejection = currentRoundDetail.value?.doc_code === 'CTNF' ? i18n.t('fileWrapperMultiView.nonFinalRejection') : i18n.t('fileWrapperMultiView.finalRejection');
    return `${mrdt} ${rejection}`;
});

const pdfLink = computed(() => {
    return _.get(rejectionData.value, 'pdf', '');
});


return { __sfc: true,i18n, currentRoundDetail, rejectionData, title, pdfLink, FileWrapperMultiViewPdf, PtIcon }
}

})